import { render, staticRenderFns } from "./OpenCard.vue?vue&type=template&id=ee5df4de&scoped=true&"
import script from "./OpenCard.vue?vue&type=script&lang=ts&"
export * from "./OpenCard.vue?vue&type=script&lang=ts&"
import style0 from "./OpenCard.vue?vue&type=style&index=0&id=ee5df4de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee5df4de",
  null
  
)

export default component.exports